<template>
  <div class="bottombar">
    <div v-if= "normal !== '1'">
      <ItemTitle title="联系我们" href="http://ccfmty.com" :needMore="false"></ItemTitle>
      <p>
        <van-icon name="phone-o" class="icon" /> 
        <span>招商合作： +86 15330613988 铁军</span>
      </p>
      <!-- <p>
        <van-icon name="comment-o" class="icon" />
        <span>邮箱：2450683543@qq.com 邮编：130000</span>
      </p> -->
      <!-- <p>
        <van-icon name="location-o" class="icon" /> 
        <span>地址：长春市净月开发区亚泰华府第Y07幢2单元103号房 </span>
      </p> -->
    </div>
    <!-- <img src="https://s10.mogucdn.com/mlcdn/c45406/200329_4de97kj4jddfhkk5d6j7e21112de9_258x258.jpg" alt="咱家马拉松" width="100"> -->
    <div class="beian">
      <p class="copyright">©{{title ? title : '疯马体育'}}</p>
      <p class="gongan">
        <a href="https://beian.miit.gov.cn">
          <span>
            <img
              class="img-center"
              src="https://s10.mogucdn.com/mlcdn/c45406/190515_0gei4681dhlh0cf9ch0g33j97d88l_20x20.png"
              alt="备案号"
            />
            吉ICP备20001316号
          </span>
        </a>
      </p>
      
    </div>
  </div>

</template>

<script>
  import ItemTitle from "@/components/ItemTitle.vue";

  export default {
    name: "BottomBar",
    props: {
      funObj: Array,
      title: String,
      normal: String
    },
    components: {
      ItemTitle
    },
    data() {
      return {
      };
    },
    computed: {
    },
    mounted() {
    },
    methods: {
      onChange(index) {
        this.active = index;
      },
    },
  };
</script>
<style scope lang="less">
  .bottombar p {
    line-height: 10px;
    font-size: 13px;
  }
  .bottombar{
    text-align: left;
    color:#333;
  }
  .beian{
    background-color: #000;
    font-size: 12px;
    color: #fff;
    padding: 1px 0;
    text-align: center;
  }
  .copyright{
    line-height: 0px;
  }
  .img-center{
    vertical-align:text-bottom;
  }
  .gongan{
    line-height: 0;
    margin-bottom: 5px;
  }
   .gongan a{
    color: #fff;
  }
  .icon{
    margin: 0 5px 0 10px;
    vertical-align: bottom;
  }
</style>
